/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsEntryCreateGuestCommentRequest
 */
export interface RevisdomAPIViewModelsEntryCreateGuestCommentRequest {
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryCreateGuestCommentRequest
     */
    versionId?: number;
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryCreateGuestCommentRequest
     */
    startFrame?: number;
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryCreateGuestCommentRequest
     */
    endFrame?: number;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryCreateGuestCommentRequest
     */
    text?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryCreateGuestCommentRequest
     */
    data?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryCreateGuestCommentRequest
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryCreateGuestCommentRequest
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryCreateGuestCommentRequest
     */
    lastName?: string | null;
}

/**
 * Check if a given object implements the RevisdomAPIViewModelsEntryCreateGuestCommentRequest interface.
 */
export function instanceOfRevisdomAPIViewModelsEntryCreateGuestCommentRequest(value: object): value is RevisdomAPIViewModelsEntryCreateGuestCommentRequest {
    return true;
}

export function RevisdomAPIViewModelsEntryCreateGuestCommentRequestFromJSON(json: any): RevisdomAPIViewModelsEntryCreateGuestCommentRequest {
    return RevisdomAPIViewModelsEntryCreateGuestCommentRequestFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryCreateGuestCommentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsEntryCreateGuestCommentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'versionId': json['versionId'] == null ? undefined : json['versionId'],
        'startFrame': json['startFrame'] == null ? undefined : json['startFrame'],
        'endFrame': json['endFrame'] == null ? undefined : json['endFrame'],
        'text': json['text'] == null ? undefined : json['text'],
        'data': json['data'] == null ? undefined : json['data'],
        'email': json['email'] == null ? undefined : json['email'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
    };
}

export function RevisdomAPIViewModelsEntryCreateGuestCommentRequestToJSON(json: any): RevisdomAPIViewModelsEntryCreateGuestCommentRequest {
    return RevisdomAPIViewModelsEntryCreateGuestCommentRequestToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryCreateGuestCommentRequestToJSONTyped(value?: RevisdomAPIViewModelsEntryCreateGuestCommentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'versionId': value['versionId'],
        'startFrame': value['startFrame'],
        'endFrame': value['endFrame'],
        'text': value['text'],
        'data': value['data'],
        'email': value['email'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
    };
}

